module.exports = __webpack_public_path__ + "img/rf_advanced_3.4bf5634a.jpg";